// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yET-","questions":"styles_questions__pV0O_","footer":"styles_footer__bb_I3"};